import { useEffect, useState } from "react";

import { Grid, Button } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";

import MaskAndValid from "utils/maskAndValid";
import themeColorsDesingSystem from "assets/theme/ds-colors";

import regionOptionsRaw from "../../publicar-vitrine/data/brazil-regions.json";
import { DEFAULT_REPRESENTATIVE_LIST_FILTERS } from "../utils/representative-helpers";

const regionOptions = [{ label: "Todas", value: "" }, ...regionOptionsRaw];

const defaultStatusOptions = [
  { id: "TODOS", value: "TODOS", label: "Todos" },
  { id: "ATIVO", value: "ATIVO", label: "Ativo" },
  { id: "DESATIVADO", value: "DESATIVADO", label: "Desativado" },
  { id: "INATIVO", value: "INATIVO", label: "Inativo" },
];

export default function RepresentativeFilters({
  isLoading,
  filters,
  onFiltersChange,
  grupoEconomicoOptions = [],
  razaoSocialOptions = [],
  showGrupoRazaoFilters = true,
  statusOptions = defaultStatusOptions,
}) {
  const defaultStatus = statusOptions[0];
  const [draft, setDraft] = useState({
    ...DEFAULT_REPRESENTATIVE_LIST_FILTERS,
    ...filters,
  });

  useEffect(() => {
    setDraft({ ...DEFAULT_REPRESENTATIVE_LIST_FILTERS, ...filters });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handleDraftChange = (key, value) => {
    setDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleCnpjChange = (e) => {
    handleDraftChange("cnpj", MaskAndValid.maskCNPJ(e.target.value));
  };

  const handleSearch = () => {
    onFiltersChange(draft);
  };

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <AutoCompleteField
          options={statusOptions}
          label="Status"
          optionLabelKey="label"
          optionIdKey="id"
          onChange={(option) =>
            handleDraftChange("status", option ?? defaultStatus)
          }
          disabled={isLoading}
          value={draft.status ?? defaultStatus}
          disableClientFilter
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <AutoCompleteField
          options={regionOptions}
          label="Região"
          optionLabelKey="label"
          optionIdKey="value"
          onChange={(option) => handleDraftChange("region", option)}
          disabled={isLoading}
          value={draft.region}
          disableClientFilter
          required={false}
        />
      </Grid>
      {showGrupoRazaoFilters && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <AutoCompleteField
            options={grupoEconomicoOptions}
            label="Grupo Econômico"
            optionLabelKey="Nome"
            optionIdKey="Id"
            onChange={(option) => handleDraftChange("grupoEconomico", option)}
            disabled={isLoading}
            value={draft.grupoEconomico}
            disableClientFilter
          />
        </Grid>
      )}
      {showGrupoRazaoFilters && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <AutoCompleteField
            options={razaoSocialOptions}
            label="Razão Social"
            optionLabelKey="Nome"
            optionIdKey="Id"
            onChange={(option) => handleDraftChange("razaoSocial", option)}
            disabled={isLoading}
            value={draft.razaoSocial}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <InputText
          placeholder="00.000.000/0000-00"
          onChange={handleCnpjChange}
          disabled={isLoading}
          value={draft.cnpj || ""}
          label="CNPJ"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputText
          placeholder="Pesquisar..."
          onChange={(e) => handleDraftChange("search", e.target.value)}
          disabled={isLoading}
          value={draft.search || ""}
          label="Pesquisar"
          props={{
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<SearchIcon />}
          onClick={handleSearch}
          disabled={isLoading}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: themeColorsDesingSystem.primary.main,
            color: "white",
            height: 38,
          }}
        >
          Pesquisar
        </Button>
      </Grid>
    </Grid>
  );
}

export { DEFAULT_REPRESENTATIVE_LIST_FILTERS };
